export default "__VITE_ASSET__eym4H9Kg__"